import request from '@/utils/request'

// 查询用户提现列表
export function listWithdrawal(query) {
  return request({
    url: '/user/user-withdrawal/list',
    method: 'get',
    params: query
  })
}

// 查询用户提现分页
export function pageWithdrawal(query) {
  return request({
    url: '/user/user-withdrawal/page',
    method: 'get',
    params: query
  })
}

// 查询用户提现详细
export function getWithdrawal(data) {
  return request({
    url: '/user/user-withdrawal/detail',
    method: 'get',
    params: data
  })
}

// 新增用户提现
export function addWithdrawal(data) {
  return request({
    url: '/user/user-withdrawal/add',
    method: 'post',
    data: data
  })
}

// 修改用户提现
export function updateWithdrawal(data) {
  return request({
    url: '/user/user-withdrawal/edit',
    method: 'post',
    data: data
  })
}

// 删除用户提现
export function delWithdrawal(data) {
  return request({
    url: '/user/user-withdrawal/delete',
    method: 'post',
    data: data
  })
}
